// import React, { useEffect } from "react";
// import { FaBars, FaBell, FaSearch, FaUserCircle } from "react-icons/fa";
// import "./Header.css";

// const Header = () => {
//   const userData = JSON.parse(localStorage.getItem("admin_user"));
//   const userName = userData ? `${userData.full_name}` : "Admin";

//   useEffect(() => {
//     document.title = userData?.full_name ? `${userData.full_name} (Admin)` : "A2Z";
//   }, [userData]);

//   return (
//     <header className="ta-header">
//       <div className="ta-header-left">
//         <button className="ta-toggle-btn">
//           <FaBars className="ta-header-icon" />
//         </button>

//         <div className="ta-search-box">
//           <FaSearch className="ta-search-icon" />
//           <input 
//             type="text" 
//             placeholder="Search..." 
//             className="ta-search-input" 
//           />
//         </div>
//       </div>

//       <div className="ta-header-right">
//         <div className="ta-notification-wrapper">
//           <button className="ta-notification-btn">
//             <FaBell />
//             <span className="ta-badge">3</span>
//           </button>
//         </div>
        
//         <div className="ta-user-profile">
//           <FaUserCircle className="ta-user-icon" />
//           <span className="ta-user-name">{userName}</span>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;


import React, { useEffect, useState } from "react";
import { FaBars, FaBell, FaSearch, FaUserCircle } from "react-icons/fa";
import "./Header.css";

const Header = ({ toggleSidebar }) => {
  const [userName, setUserName] = useState(""); 
  const User = localStorage.getItem("tenant_user");
  

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("tenant_user");

      if (storedUser) {
        const userData = JSON.parse(storedUser);
        setUserName(userData?.full_name || "User");

        // Set page title
        document.title = `${userData?.full_name || "User"} (SuperAdmin)`;
      } else {
        document.title = "A2Z";
      }
    } catch (error) {
      console.error("Error reading localStorage:", error);
    }
  }, []);
 


  return (
    <header className="ta-header">
      <div className="ta-header-left">
        

        <div className="ta-search-box">
          <FaSearch className="ta-search-icon" />
          <input
            type="text"
            placeholder="Search..."
            className="ta-search-input"
          />
        </div>
      </div>

      <div className="ta-header-right">
        <div className="ta-notification-wrapper">
          <button className="ta-notification-btn">
            <FaBell />
            <span className="ta-badge">3</span>
          </button>
        </div>

        <div className="ta-user-profile">
          <FaUserCircle className="ta-user-icon" />
          <span className="ta-user-name">{userName}</span>
        </div>
      </div>
    </header>
  );
};

export default Header;